import axios from '@axios'

export class FilterServices{
    static async  getFilterOptionsBy(ctx, q) {
     
        return new Promise((resolve, reject) => {
          axios.get('filters/getFilterBy', { params: {type:'device',categories:['COMPACTOR'],isSupport:true} })
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
      }

}

